import { CERCAS_MODULE, CERCAS_VIEW_ANY, CERCAS_MANAGE_ANY } from '@/modules/cercas-virtuais/helpers/permissions'
import { useCercasStore } from '@/store/cercasStore'

const LIST_RESTORE_FROM = new Set(['cerca-virtual-detalhe', 'cerca-virtual-nova'])

const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsApp = { name: 'Aplicativo', pathName: null }
const breadcrumbsCercas = { name: 'Cercas virtuais', pathName: '/v3/cercas-virtuais' }

// Gates de rota. `visualizar` OU `gerenciar` para ver a listagem; só `gerenciar` para as
// telas de escrita. O guard global (src/router/router-guard.js) lê este meta e manda para
// `restrict-access` quem não passa.
const viewGate = { requiredModules: [CERCAS_MODULE], requiredUserPermissions: CERCAS_VIEW_ANY, requiredUserPermissionsMatch: 'any' }
const manageGate = { requiredModules: [CERCAS_MODULE], requiredUserPermissions: CERCAS_MANAGE_ANY, requiredUserPermissionsMatch: 'any' }

export default [
  {
    path: '/v3/cercas-virtuais',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: '',
        name: 'cercas-virtuais',
        component: () => import('@/modules/cercas-virtuais/views/pages/Index.vue'),
        beforeEnter(to, from, next) {
          if (LIST_RESTORE_FROM.has(from.name)) {
            useCercasStore().prepareListRestore()
          }
          next()
        },
        meta: {
          title: 'Cercas virtuais',
          ...viewGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, { name: 'Cercas virtuais', pathName: null }],
        },
      },
      {
        // Rota estática ANTES de :id para não ser capturada pelo param.
        path: 'nova',
        name: 'cerca-virtual-nova',
        component: () => import('@/modules/cercas-virtuais/views/pages/CercaForm.vue'),
        meta: {
          title: 'Nova cerca virtual',
          ...manageGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, breadcrumbsCercas, { name: 'Nova cerca virtual', pathName: null }],
        },
      },
      {
        path: ':id',
        name: 'cerca-virtual-detalhe',
        component: () => import('@/modules/cercas-virtuais/views/pages/CercaDetalhe.vue'),
        meta: {
          title: 'Detalhes da cerca virtual',
          // `manageGate`, não `viewGate`: apesar do nome, esta tela é de EDIÇÃO — monta o
          // CercaForm e o rodapé de ações (Inativar, Salvar, Publicar). O `readOnly` do
          // formulário depende do STATUS da cerca (inativa/expirada), não da permissão do
          // usuário, então com `viewGate` o perfil Acesso chegava aqui por URL direta e
          // recebia o formulário editável. É por isso também que o painel de resumo esconde
          // "Ver mais detalhes" desse perfil.
          ...manageGate,
          breadcrumbs: [breadcrumbsHome, breadcrumbsApp, breadcrumbsCercas, { name: 'Detalhes', pathName: null }],
        },
      },
    ],
  },
]
